/**
 * Zoy Featured In Slider
 * - Autoplay carousel with animated progress bar
 * - Touch swipe (mobile) + Mouse drag (desktop) pause/resume logic
 */
function initZoyFeaturedIn(sectionId, logosPerView, autoplay, autoplaySpeed) {
  const section = document.querySelector('.section-' + sectionId);
  if (!section) return;

  const track = section.querySelector('#zfi-track-' + sectionId);
  const slides = section.querySelectorAll('.zfi-slide');
  const progressBar = section.querySelector('#zfi-progress-' + sectionId);

  if (!track || slides.length === 0) return;

  let current = 0;
  let startX = 0;
  let isDragging = false;
  let autoplayTimer = null;
  const total = slides.length;

  function getGap() {
    return window.innerWidth <= 640 ? 16 : 24;
  }

  function getPerView() {
    if (window.innerWidth <= 640) return 2;
    if (window.innerWidth <= 1024) return 3;
    return Math.min(logosPerView, total);
  }

  function getMaxIndex() {
    return Math.max(0, total - getPerView());
  }

  function updateProgress(idx, maxIdx) {
    if (!progressBar) return;
    const perView = getPerView();
    const pct = maxIdx === 0 ? 100 : ((idx + perView) / total) * 100;
    progressBar.style.width = Math.min(100, pct) + '%';
  }

  function goTo(idx) {
    const maxIndex = getMaxIndex();
    
    // Loop back to start if we slide past the end, otherwise clamp
    if (idx > maxIndex) {
      current = 0;
    } else if (idx < 0) {
      current = maxIndex;
    } else {
      current = idx;
    }

    const slideWidth = slides[0].offsetWidth;
    const gap = getGap();
    track.style.transform = 'translateX(-' + (current * (slideWidth + gap)) + 'px)';

    updateProgress(current, maxIndex);
  }

  function startAutoplay() {
    if (!autoplay || getMaxIndex() === 0) return;
    stopAutoplay();
    autoplayTimer = setInterval(() => {
      goTo(current + 1);
    }, autoplaySpeed);
  }

  function stopAutoplay() {
    if (autoplayTimer) {
      clearInterval(autoplayTimer);
      autoplayTimer = null;
    }
  }

  // Touch swipe (pauses autoplay, resumes on end)
  track.addEventListener('touchstart', (e) => {
    stopAutoplay();
    startX = e.touches[0].clientX;
    isDragging = true;
  }, { passive: true });

  track.addEventListener('touchend', (e) => {
    if (!isDragging) return;
    const diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) {
      goTo(diff > 0 ? current + 1 : current - 1);
    }
    isDragging = false;
    startAutoplay();
  }, { passive: true });

  // Mouse drag (pauses autoplay, resumes on release)
  track.addEventListener('mousedown', (e) => {
    if (getMaxIndex() === 0) return;
    stopAutoplay();
    startX = e.clientX;
    isDragging = true;
  });

  window.addEventListener('mouseup', (e) => {
    if (!isDragging) return;
    const diff = startX - e.clientX;
    if (Math.abs(diff) > 40) {
      goTo(diff > 0 ? current + 1 : current - 1);
    }
    isDragging = false;
    startAutoplay();
  });

  // Init & resize
  goTo(0);
  startAutoplay();

  window.addEventListener('resize', () => {
    goTo(Math.min(current, getMaxIndex()));
    startAutoplay();
  });
}

/* ── Self-initialize every Featured In section ── */
(function () {
  function initAll() {
    document.querySelectorAll('[data-zoy-featured-in]').forEach(function (el) {
      if (el.dataset.zoyFeaturedInInit) return;
      el.dataset.zoyFeaturedInInit = '1';
      var id = el.getAttribute('data-section-id');
      var per = parseInt(el.getAttribute('data-logos-per-view'), 10) || 5;
      var auto = el.getAttribute('data-autoplay') !== 'false';
      var speed = parseInt(el.getAttribute('data-autoplay-speed'), 10) || 4;
      try { initZoyFeaturedIn(id, per, auto, speed * 1000); } catch (e) { /* fail silently */ }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Theme editor re-renders
  document.addEventListener('shopify:section:load', initAll);
})();
